import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import RadioBlock from '../../../../../../../components/Form/RadioBlock'
import Field from '../../../../../../../components/Form/Field'

import { formatOptionsList } from '../../../../../../../features/formatters'

import {
  ENGAGEMENT_TYPE,
  POST_ENGAGEMENT,
  THRUPLAY,
  TWO_SECOND_CONTINUOUS_VIDEO_VIEWS
} from '../../../../../LineItemForms/LineItemFacebookCreate/LineItemFacebookCreateForm/fields'
import { PAGE_LIKES } from '../../../../../../../constants/reusableObjectives'
import { FB_PAGE_CHOICE } from '../../../../../AdForms/fields'

import {
  accessibleSocialPagesIsLoadingSelector,
  accessibleSocialPagesSelector
} from '../../../../../../../modules/selectors/socialAccounts'

const ObjectiveStep = ({ formik, handleStepChange }) => {
  const { t } = useTranslation()

  const { values, setFieldValue } = formik

  const facebookPages = useSelector(accessibleSocialPagesSelector)
  const facebookPagesLoading = useSelector(accessibleSocialPagesIsLoadingSelector)

  const formattedFacebookPages = useMemo(() => {
    return formatOptionsList({
      list: facebookPages,
      valueName: 'external_id',
      labelName: 'name'
    })
  }, [facebookPages])

  const handleContinue = useCallback(() => {
    handleStepChange()
  }, [handleStepChange])

  return (
    <>
      <Step stepTitle="Please select an objective" handleContinue={handleContinue}>
        <RadioBlock
          setFieldValue={setFieldValue}
          id={ENGAGEMENT_TYPE + POST_ENGAGEMENT}
          name={ENGAGEMENT_TYPE}
          value={POST_ENGAGEMENT}
          selectedValue={values[ENGAGEMENT_TYPE]}
          label={t('Post engagement')}
        />
        <RadioBlock
          setFieldValue={setFieldValue}
          id={ENGAGEMENT_TYPE + PAGE_LIKES}
          name={ENGAGEMENT_TYPE}
          value={PAGE_LIKES}
          selectedValue={values[ENGAGEMENT_TYPE]}
          label={t('Page likes')}
        >
          <Field
            placeholder={t('Facebook page')}
            formik={formik}
            name={FB_PAGE_CHOICE}
            options={formattedFacebookPages}
            isLoading={facebookPagesLoading}
            isMulti={false}
            isSearchable={false}
            preselectFirstOptionValue={true}
          />
        </RadioBlock>
        <RadioBlock
          setFieldValue={setFieldValue}
          id={ENGAGEMENT_TYPE + THRUPLAY}
          name={ENGAGEMENT_TYPE}
          value={THRUPLAY}
          selectedValue={values[ENGAGEMENT_TYPE]}
          label={t('Maximise ThruPlay Views')}
        />
        <RadioBlock
          setFieldValue={setFieldValue}
          id={ENGAGEMENT_TYPE + TWO_SECOND_CONTINUOUS_VIDEO_VIEWS}
          name={ENGAGEMENT_TYPE}
          value={TWO_SECOND_CONTINUOUS_VIDEO_VIEWS}
          selectedValue={values[ENGAGEMENT_TYPE]}
          label={t('Maximise 2s continuous video plays')}
        />
      </Step>
    </>
  )
}

export default ObjectiveStep
